module.exports = __webpack_public_path__ + "img/10.19a3fd24.jpg";